import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import styled from "styled-components";
import useOnclickOutside from "react-cool-onclickoutside";

// Styled components

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  background: black;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease, box-shadow 0.3s ease;
  
  &.sticky {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  img {
    height: 2em;
  }
`;

// Desktop navigation (hidden on mobile)
const Nav = styled.nav`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

// NavItem: Force all link states to white and scale slightly on hover.
const NavItem = styled(Link)`
  margin: 0 1rem;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.3s ease;

  /* Force white color on all states */
  color: white !important;
  &:link,
  &:visited,
  &:hover,
  &:active {
    color: white !important;
    text-decoration: none;
  }

  &:hover {
    transform: scale(1.05);
  }
`;

// Mobile menu icon (hamburger)
const MobileMenuIcon = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  
  @media (max-width: 768px) {
    display: block;
  }
  
  .bar {
    width: 1.5rem;
    height: 0.2rem;
    background: white;
    margin: 0.3rem 0;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
`;

// Mobile menu container (slide-in from right)
const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: ${({ open }) => (open ? "0" : "-100%")};
  width: 70%;
  height: 100vh;
  background: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 4rem;
  transition: right 0.3s ease;
  z-index: 99;

  a {
    margin: 1rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    transition: transform 0.3s ease;
    cursor: pointer;
    /* Force white color on all states for mobile links as well */
    color: white !important;
    &:link,
    &:visited,
    &:hover,
    &:active {
      color: white !important;
      text-decoration: none;
    }
    &:hover {
      transform: scale(1.05);
    }
  }
`;

// The Header Component

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  
  // Close mobile menu on outside click.
  const ref = useOnclickOutside(() => {
    if (showMenu) setShowMenu(false);
  });

  // Optional: add a "sticky" class when scrolling.
  useEffect(() => {
    const header = document.getElementById("header");
    const handleScroll = () => {
      if (window.pageYOffset > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <HeaderContainer id="header">
        <Logo to="/">
          <img src="./img/ciegalogo-01.svg" alt="Logo" />
        </Logo>

        <Nav>
          <NavItem to="/case-studies">Case Studies/Work</NavItem>
          <NavItem to="/contact">Contact</NavItem>
          <NavItem to="/blog">Blog</NavItem>
        </Nav>

        <MobileMenuIcon onClick={() => setShowMenu(!showMenu)}>
          <div
            className="bar"
            style={{
              transform: showMenu
                ? "rotate(45deg) translate(5px, 5px)"
                : "none"
            }}
          ></div>
          <div
            className="bar"
            style={{ opacity: showMenu ? 0 : 1 }}
          ></div>
          <div
            className="bar"
            style={{
              transform: showMenu
                ? "rotate(-45deg) translate(5px, -5px)"
                : "none"
            }}
          ></div>
        </MobileMenuIcon>
      </HeaderContainer>

      <MobileMenu ref={ref} open={showMenu}>
        <NavItem to="/case-studies" onClick={() => setShowMenu(false)}>
          Case Studies/Work
        </NavItem>
        <NavItem to="/contact" onClick={() => setShowMenu(false)}>
          Contact
        </NavItem>
        <NavItem to="/blog" onClick={() => setShowMenu(false)}>
          Blog
        </NavItem>
      </MobileMenu>
    </>
  );
};

export default Header;
